module.exports = __webpack_public_path__ + "static/IDS4312D-397e8f372a60bb5ab15dc41e32179084.png";